<template>
  <OldGuiFrame v-if="!showNewTimeReport">
  </OldGuiFrame>

  <TimeReportTable v-else :height="contentHeight" :reportFilter="reportFilter" :defaultColumns="columns"
    :tableStorageKey="'TimeReportTable'">
  </TimeReportTable>
</template>


<script>
import TimeReportTable from "./TimeReportTable2.vue";
import OldGuiFrame from "@/views/landingpages/OldGuiFrame.vue"

export default {
  name: "MyHours",
  props: [],
  components: {
    TimeReportTable,
    OldGuiFrame,
  },
  mixins: [],

  data() {
    return {
      columns: {
        EmploymentTimeReportDate: {
          prop: 'EmploymentTimeReportDate', label: this.$t('servicesystem.common_objects.commonterms.date'), show: true, width: 90
        },
        ParentJobId: {
          prop: 'ParentJobId', label: this.$t('servicesystem.common_objects.order.order'), show: true, width: 90, minWidth: 80
        },
        CustomerId: {
          prop: 'CustomerId', label: this.$t('servicesystem.common_objects.customer.customer'), show: true, minWidth: 130
        },
        JobId: {
          prop: 'JobId', label: this.$t('servicesystem.common_objects.machine.machine'), show: true, minWidth: 180
        },
        ArticleNumber: {
          prop: 'ArticleNumber', label: this.$t('servicesystem.common_objects.article.article'), show: false, width: 100, minWidth: 100
        },
        StartDateTime: {
          prop: 'StartDateTime', label: this.$t('servicesystem.common_objects.commonterms.start'), show: true, width: 69, align: 'right'
        },
        ArticleCount: {
          prop: 'Duration', label: this.$t('servicesystem.common_objects.time_report.duration'), show: true, width: 69, align: 'right'
        },
        StopDateTime: {
          prop: 'StopDateTime', label: this.$t('servicesystem.common_objects.commonterms.end'), show: true, width: 69, align: 'right'
        },
        ArticleDescription: {
          prop: 'ArticleDescription', label: this.$t('servicesystem.common_objects.order.description'), show: false, minWidth: 200
        },
        Actions: {
          prop: 'Actions', label: this.$t('servicesystem.common_objects.commonterms.actions'), show: 'always', minWidth: 45, width: 48, align: 'center', fixed: 'right'
        },
      },
    };
  },

  mounted() { },

  methods: {},

  computed: {
    showNewTimeReport() {
      return this.$store.state.GlobalSettings.ShowNewTimeReport;
    },

    reportFilter() {
      return {
        FromDate: this.startDate,
        ToDate: this.endDate,
        EmploymentId: this.userInfo?.EmploymentId?.trim(),
      }
    },

    daterange() {
      return this.$store.state.triggerevents.reportDateRange;
    },
    startDate() {
      return this.daterange?.[0];
    },
    endDate() {
      return this.daterange?.[1];
    },

    contentHeight() {
      return this.$store.getters['navstore/ContentContainerHeight'];
    },
  },

  watch: {},
};
</script>


<style lang='scss'></style>